import React from "react";
import NavigationBar from "../components/NavigationBar";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import SideMenu from "../components/SideMenu";
import ProjectContextProvider from "../contexts/ProjectContextProvider";
import styles from "./MainLayout.module.css";
import MediaPlayerModal from "../components/modals/MediaPlayerModal";

//layout with upper navigation bar and the side bar
const MainLayout = () => {
  return (
    <ProjectContextProvider>
      <NavigationBar />
      <div style={{ minHeight: "80vh" }} className="mx-0 d-flex">
        <aside
          className={`${styles.sideMenu} d-none d-lg-block w-100`}
          style={{ minWidth: "300px", maxWidth: "320px" }}
        >
          <SideMenu />
        </aside>
        <main className={`w-100 ${styles.mainContent}`}>
          <Outlet />
        </main>
      </div>
      <Footer />
      <MediaPlayerModal />
    </ProjectContextProvider>
  );
};

export default MainLayout;
